import { resolveCropKeyframeAtTime } from '@/lib/crop/resolveCropKeyframeAtTime';
import type { CropCenterKeyframeLike } from '@/lib/cover/resolveCropCenterXAtTime';

/** A reframe as 0..1 fractions of the source, plus its zoom (>= 1). */
export interface CoverCropFraming {
  centerX: number;
  centerY: number;
  zoom: number;
}

const toFraction = (percent: number) => (
  Number.isFinite(percent) ? Math.min(1, Math.max(0, percent / 100)) : 0.5
);

/**
 * The reframe the preview and the export apply at a source-video time
 * (`resolveCropKeyframeAtTime`: the covering keyframe, else the previous one
 * held across a gap, else the first), for cropping a captured frame the same
 * way. The camera-move tween between cuts is not reproduced: a capture
 * mid-tween uses the covering keyframe.
 */
export function resolveCropFramingAtTime(
  keyframes: readonly (CropCenterKeyframeLike & { zoom?: number })[] | null | undefined,
  sourceTime: number,
): CoverCropFraming | null {
  const keyframe = resolveCropKeyframeAtTime(keyframes, sourceTime);
  if (!keyframe) return null;
  const zoom = typeof keyframe.zoom === 'number' && Number.isFinite(keyframe.zoom) && keyframe.zoom > 0
    ? keyframe.zoom
    : 1;
  return { centerX: toFraction(keyframe.x), centerY: toFraction(keyframe.y), zoom };
}
